import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import { Input, NotificationContainer, Dropdown, DropdownOption, WithTooltip, Tooltip, Icon } from "@abb/abb-common-ux-react";

import SubmitHeader from "../shared/SubmitHeader";

import history from "../../utilities/History";

import IUserFormData, {
  UserFormData, IRoleList, defaultRoleData, userPostData
} from "../../models/user/UserFormData";

import userActions from "../../flux/actions/UserActions";
import userRoleStore from "../../flux/stores/user/RoleStore";
import userCreateStore from "../../flux/stores/user/CreateStore";
import userListStore from "../../flux/stores/user/ListStore";

import userFormStore from "../../flux/stores/user/FormStore";
import IFormComponent from "../../models/shared/FormComponent";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";

import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import { Translation } from "react-i18next";

import triggerNotifications from "../../utilities/TriggerNotifications";
import auth from "../../utilities/Auth";

import { defaultUserData } from "../../models/user/UserViewData";



// Todo: Understand
type PropsType = RouteComponentProps & {};
// End

interface IFormState {
  userFormData: IUserFormData;
  selectedRole: {
    label: string,
    value: string
   }[];
  userRoles: IRoleList;
  selectedUserRoles: IRoleList;
  userCreated: boolean;
  disableRole: boolean;
  userNameError: boolean;
  firstNameError: boolean;
  lastNameError: boolean;
  passwordError: boolean;
  emailError: boolean;
  isRevelPassword: boolean;
  userListData: any;
}

class CreateUser extends React.Component<PropsType, IFormState> implements IFormComponent {
  _mount: boolean;
  _isReload: boolean;
  _id: string;
  _oldUserRoles: any = [];

  constructor(props: PropsType) {
    super(props);
    const pushStateData = this.props.location.state as IUserFormData;
    this.state = {
      userFormData: pushStateData,
      selectedRole: [{
        label: "",
        value: ""
      }],
      userRoles: defaultRoleData,
      selectedUserRoles: defaultRoleData,
      userCreated: false,
      disableRole: false,
      userNameError: false,
      firstNameError: false,
      lastNameError: false,
      passwordError: false,
      emailError: false,
      isRevelPassword: false,
      userListData: defaultUserData,
    };
    this._mount = false;
  }

  private setFirstName = (value: string) => {
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      const userFormData = this.state.userFormData;
      userFormData.firstName = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        userFormData,
        firstNameError: false
      },this.validate)
    } else{
      const userFormData = this.state.userFormData;
      userFormData.firstName = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        userFormData,
        firstNameError: true
      },this.validate)
    }
  }

  private setLastName = (value: string) => {
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      const userFormData = this.state.userFormData;
      userFormData.lastName = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        userFormData,
        lastNameError: false
      },this.validate)
    } else{
      const userFormData = this.state.userFormData;
      userFormData.lastName = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        userFormData,
        lastNameError: true
      },this.validate)
    }
  }

  private setDescription = (value: string) => {
      const userFormData = this.state.userFormData;
      userFormData.description = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        userFormData
      })
  }

  private setEmail = (value: string) => {
    if(value !== ""){
      const userFormData = this.state.userFormData;
      userFormData.email = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        userFormData
      },this.validate)
    } else{
      const userFormData = this.state.userFormData;
      userFormData.email = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        emailError: false
      },this.validate)
    }
  }

  private emailValidation = (value: string) =>{
    if(value !== ""){
      if(value.trim() && (/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/.test(value))){
        this.setState({
          emailError: false
        },this.validate)
      } else{
        this.setState({
          emailError: true
        },this.validate)
      }
    }
  }

  private userNameDupliateValidation = (value: string) => {
    if(value.trim() && this.state.userListData.find((x:any) => x.username.toLowerCase() === value.toLowerCase())){
      this.setState({
        userNameError: true
      },this.validate)
    } else{
      this.setState({
        userNameError: false
      },this.validate)
    }
  }

  private setUserName = (value: string) => {
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      const userFormData = this.state.userFormData;
      userFormData.username = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        userFormData,
        userNameError: false
      },this.validate)
    } else{
      const userFormData = this.state.userFormData;
      userFormData.username = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        userFormData,
        userNameError: true
      },this.validate)
    }
  }

  private setPassword = (value: string) => {
      const userFormData = this.state.userFormData;
      userFormData.password = value.length  ? value : value.replace(/\s/g, "");
      this.setState({
        userFormData
      },this.validate)
      if(!this.state.userFormData.isEditMode){
        value.length !== 0 ? this.setState({passwordError: false}) : this.setState({passwordError: true})
      }
  }

  private setRole = (value: any) => {
    var tempRole = [{ label: value[0].label, value: value[0].value }];
    this.setState({
      selectedRole: tempRole,
    },this.validate)
    var a = JSON.parse(JSON.stringify(this.state.userFormData.role.id));
    var b = JSON.parse(JSON.stringify(this.state.userFormData.role.name));
    let oldClientRole = a !== value[0].value ? this.state.userRoles.clientRoles.filter((x:any) => x.name === b) : []
    let oldRealmRole = a !== value[0].value ? this.state.userRoles.realmRoles.filter((x:any) => x.name === b) : []
    var clientRole = this.state.userRoles.clientRoles.filter((x:any) => x.name === value[0].label)
    var realmRole = this.state.userRoles.realmRoles.filter((x:any) => x.name === value[0].label)
    const userFormData = this.state.userFormData;
    userFormData.role = value.length  ? clientRole[0] : value.replace(/\s/g, "");
    const selectedUserRoles = this.state.selectedUserRoles;
    selectedUserRoles.clientRoles = clientRole;
    selectedUserRoles.realmRoles = realmRole;
    this._oldUserRoles.clientRoles = oldClientRole;
    this._oldUserRoles.realmRoles = oldRealmRole;

    this.setState({
      userFormData,
      selectedUserRoles,
    })
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    if (this.state.userFormData.isEditMode) {

      var tempRole = [{ label: this.state.userFormData.role.name, value: this.state.userFormData.role.id }];
      this.setState({
        selectedRole: tempRole,
      })

      submitHeaderActions.update({
        moduleName: CONSTANTS.MODULE_USERS,
        isSubmitDisabled: false
      }).then();
    }

    if (this._mount) {
      navigationHeaderActions.updateHeader({
        name: CONSTANTS.MODULE_USERS,
        action: this.state.userFormData.isEditMode ? CONSTANTS.EDIT : CONSTANTS.CREATE,
        icon: this.state.userFormData.isEditMode ? ICONCONSTANTS.ABB_EDIT : ICONCONSTANTS.ABB_PLUS,
        goBackUrl: CONSTANTS.USER_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      }).then();
    }

    userRoleStore.on('change', (state) => {
      const data = state.userRoleList as IRoleList;
      this.setState({userRoles: data})
    });

    userListStore.on('change', (state) => {
      this.setState({userListData: state.userDataList})
    });

    userCreateStore.on('change', (state) => {
      const data = state.data;
    });

    userFormStore.on('change', (state) => {
      const data = state.data;
    })

    userActions.getAllRoles().then(() => {
      var clientRole = this.state.userRoles.clientRoles.filter((x:any) => x.name === this.state.userFormData.role.name)
      var realmRole = this.state.userRoles.realmRoles.filter((x:any) => x.name === this.state.userFormData.role.name)
      const selectedUserRoles = this.state.selectedUserRoles;
      selectedUserRoles.clientRoles = clientRole;
      selectedUserRoles.realmRoles = realmRole;
      this.setState({
        selectedUserRoles: selectedUserRoles,
      })
    });

    if(auth.getUserId() === this.state.userFormData.id){
      this.setState({disableRole: true})
    } else{
      this.setState({disableRole: false})
    }
    userActions.getAll().then();
  }

  validate(): void {
    const passwordValidation = !this.state.userFormData.isEditMode ? this.state.userFormData.password : true
    if (
      this.state.userFormData.firstName &&
      this.state.userFormData.lastName &&
      this.state.userFormData.username &&
      this.state.selectedRole[0].label && 
      !this.state.firstNameError &&
      !this.state.lastNameError &&
      !this.state.userNameError &&
      !this.state.emailError &&
      !this.state.passwordError &&
      passwordValidation
    ) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_USERS,
          isSubmitDisabled: false,
        })
        .then();
    } else {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_USERS,
          isSubmitDisabled: true,
        })
        .then();
    }
  }

  public onSaveClick = () => {
    const data: userPostData = {
      userFormData: this.state.userFormData,
      roleData: this.state.selectedUserRoles,
      oldRoleData: this._oldUserRoles
    }

    userActions.put(data).then(() => {
      triggerNotifications.success([CONSTANTS.USER_UPDATED])
      if(auth.getUserId() === this.state.userFormData.id && this.state.userFormData.password !== undefined){
        setTimeout(() => {
          auth.removeTokens();
          history.push(CONSTANTS.LOGIN_URL);
        },200)
      } else{
        setTimeout(() => {
          history.push(CONSTANTS.USER_INDEX_URL,{
            isReloadFirst: false,
            id: this.state.userFormData.id,
          });
        },200)
      }
    }).catch((error: any) => {
        triggerNotifications.errors(error).then()
    });
  };

  public onCreateClick = () => {
    const data: userPostData = {
      userFormData: this.state.userFormData,
      roleData: this.state.selectedUserRoles,
    }
    userActions.post(data).then(() => {
      setTimeout(() => {
        history.push(CONSTANTS.USER_INDEX_URL);
      },2000)
    }).catch((error: any) => {
        triggerNotifications.errors(error.message, error.data).then()
    });
  };

  private typeChangeHandler = (e: any) => {

  }

  private onCancelClick = () => {
    history.push(CONSTANTS.USER_INDEX_URL, {
      isReloadFirst: this._isReload,
      id: this._id,
    });
  };

  private togglePassword = () => {
    this.setState({
      isRevelPassword: !this.state.isRevelPassword,
    });
  }
  
  public render() {
    return (
      <Translation>
        {
          t =>
            <div className="page-scroll">
              <div className="layout-container">
                <SubmitHeader
                  name={t(CONSTANTS.MODULE_USERS)}
                  link={CONSTANTS.USER_INDEX_URL}
                  isEdit={this.state.userFormData.isEditMode}
                  onSaveClick={this.onSaveClick}
                  onCancelClick={this.onCancelClick}
                  onCreateClick={this.onCreateClick}
                />
                <div className="mt-3">
                  <div className="col-6 no-padding float-left">
                    <div className="box-1">
                      <div className="box-circle">
                        <p className="box-circle-text"> 1 </p>
                      </div>
                      <div className="ml-4">
                        <p className="sidebar-main-title font-weight-bold ml-2">{t(CONSTANTS.USER_DETAILS)}</p>
                      </div>
                      <hr className="hr-line" />

                      <div className="row mt-2">
                        <div className="col-sm-9 col-md">
                          <Input
                            inputAttributes={{ 'autoFocus': "true" }}
                            dataType="text"
                            placeholder={t(CONSTANTS.LABEL_FIRST_NAME)}
                            label={t(CONSTANTS.LABEL_FIRST_NAME)}
                            required={true}
                            className={
                              this.state.firstNameError
                                ? "error-code mt-2 w-50"
                                : "mt-2 w-50"
                            }
                            value={this.state.userFormData.firstName}
                            onValueChange={this.setFirstName}
                            showValidationBarWhenInvalid={this.state.firstNameError}
                            maxLength={50}
                            description={
                              this.state.firstNameError ?
                              this.state.userFormData.firstName !== "" ? 
                              t(CONSTANTS.FIRSTNAME_VALIDATION_ERROR) :
                              t(CONSTANTS.FIELD_EMPTY_ERROR) : ""
                            }
                          />
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-sm col-md">
                          <Input
                            dataType="text"
                            placeholder={t(CONSTANTS.LABEL_LAST_NAME)}
                            label={t(CONSTANTS.LABEL_LAST_NAME)}
                            required={true}
                            className={
                              this.state.lastNameError
                                ? "error-code mt-2 w-50"
                                : "mt-2 w-50"
                            }
                            value={this.state.userFormData.lastName}
                            onValueChange={this.setLastName}
                            showValidationBarWhenInvalid={this.state.lastNameError}
                            maxLength={50}
                            description={
                              this.state.lastNameError ?
                              this.state.userFormData.lastName !== "" ? 
                              t(CONSTANTS.LASTNAME_VALIDATION_ERROR) :
                              t(CONSTANTS.FIELD_EMPTY_ERROR) : ""
                            }
                          />
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-sm col-md">
                          <Input
                            dataType="email"
                            label={t(CONSTANTS.LABEL_EMAIL)}
                            placeholder={t(CONSTANTS.LABEL_EMAIL)}
                            value={this.state.userFormData.email}
                            onValueChange={this.setEmail}
                            className={
                              this.state.emailError
                                ? "error-code mt-2 w-50"
                                : "mt-2 w-50"
                            }
                            showValidationBarWhenInvalid={this.state.emailError}
                            onLostFocus={() => this.emailValidation(this.state.userFormData.email)}
                            onGotFocus={() => this.setState({emailError: false})}
                            description={
                              this.state.emailError ?
                              t(CONSTANTS.EMAIL_VALIDATION_ERROR) : ""
                            }
                            maxLength={72}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-6 no-padding float-left">
                    <div className="box-2 ml-3">
                      <div className="box-circle">
                        <p className="box-circle-text"> 2 </p>
                      </div>
                      <div className="ml-4">
                        <p className="sidebar-main-title font-weight-bold ml-2">{t(CONSTANTS.LABLE_ADDITIONAL_INFORMATION)}</p>
                      </div>
                      <hr className="hr-line" />

                      <div className="row mt-2">
                        <div className="col-sm col-md">
                          <Input
                            className={
                              this.state.userNameError
                                ? "error-code mt-2 w-50"
                                : "mt-2 w-50"
                            }
                            dataType="text"
                            label={t(CONSTANTS.LABLE_INSTRUMENT_USERNAME)}
                            placeholder={t(CONSTANTS.LABLE_INSTRUMENT_USERNAME)}
                            required={true}
                            value={this.state.userFormData.username}
                            onValueChange={this.setUserName}
                            showValidationBarWhenInvalid={this.state.userNameError}
                            disabled={this.state.userFormData.isEditMode}
                            maxLength={50}
                            onLostFocus={() => this.userNameDupliateValidation(this.state.userFormData.username)}
                            description={
                              this.state.userNameError ?
                              this.state.userFormData.username !== "" ? 
                              t(CONSTANTS.USERNAME_VALIDATION_DUPLICATE_ERROR) :
                              t(CONSTANTS.FIELD_EMPTY_ERROR) : ""
                            }
                          />
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-sm col-md">
                          <Input
                            className={
                              (this.state.passwordError && !this.state.userFormData.isEditMode)
                                ? "error-code mt-2 w-50"
                                : "mt-2 w-50"
                            }
                            dataType={
                              this.state.isRevelPassword ? "text" : "password"
                            }
                            label={t(CONSTANTS.LABLE_INSTRUMENT_PASSWORD)}
                            placeholder={t(CONSTANTS.LABLE_INSTRUMENT_PASSWORD)}
                            required={!this.state.userFormData.isEditMode}
                            onValueChange={this.setPassword}
                            value={this.state.userFormData.password}
                            showValidationBarWhenInvalid={(this.state.passwordError && !this.state.userFormData.isEditMode)}
                            icon={
                              this.state.isRevelPassword ? ICONCONSTANTS.ABB_VIEW : ICONCONSTANTS.ABB_HIDE
                            }
                            onIconClick={() => this.togglePassword()}
                            maxLength={15}
                            style={{display: "inline-block"}}
                            description={
                              (this.state.passwordError && !this.state.userFormData.isEditMode) ? t(CONSTANTS.FIELD_EMPTY_ERROR) : ""
                            }
                          />
                          <span style={{marginLeft: "0.5em",display: "inline-block",verticalAlign: "middle"}}>
                          <WithTooltip>
                            <Icon
                              name={ICONCONSTANTS.ABB_INFORMATION}
                              sizeClass="small"
                              className="blue-color cursor-pointer"
                            />
                            <Tooltip>
                              <p>{t(CONSTANTS.USER_PASSWORD)}</p>
                            </Tooltip>
                          </WithTooltip>
                          </span>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-sm col-md">
                          <Dropdown
                            className="mt-2 w-50"
                            label={t(CONSTANTS.LABEL_ROLE)}
                            allowAdd={false}
                            required={true}
                            clearable={false}
                            placeholder={t(CONSTANTS.NO_ROLE_SELECTED)}
                            searchable={true}
                            value={this.state.selectedRole}
                            onChange={(value) => this.setRole(value)}
                            disabled={this.state.disableRole}
                            
                          >
                            {this.state.userRoles.clientRoles?.map((o: any, index) => (
                                (o.name !== "" && o.id !== "") ? (<DropdownOption key={index} label={o.name} value={o.id} />) : 
                                (<DropdownOption key={index} label={"Administrator"} value={"Administrator"} />)
                            ))}
                          </Dropdown>
                        </div>
                      </div>




                    </div>
                  </div>
                </div>
                <NotificationContainer
                  actionHandler={{ remove: () => { } }}
                  className="notification"
                />
              </div>
            </div>
        }
      </Translation>
    );
  }
}

export default withRouter(CreateUser);
